module.exports = __webpack_public_path__ + "static/media/boxes.0b5c3b17.svg";